

















import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class Settings extends Vue {

    tempBatchCount = "0";
    tempWorkerCount = "0";
    tempCsvDelimiter = "";

    @Prop()
    value!: any;

    @Watch("value", { immediate: true })
    updateSettings() {
        this.tempBatchCount = this.value.batchCount;
        this.tempWorkerCount = this.value.workerCount;
        this.tempCsvDelimiter = this.value.csvDelimiter;
    }

    save() {
        this.$emit("input", {
            batchCount: parseInt(this.tempBatchCount, 10),
            workerCount: parseInt(this.tempWorkerCount, 10),
            csvDelimiter: this.tempCsvDelimiter
        });
        this.back();
    }

    back() {
        this.$router.back();
    }

}
